import { render, staticRenderFns } from "./houseConnectionForm.vue?vue&type=template&id=8b96b4f0&scoped=true&"
import script from "./houseConnectionForm.vue?vue&type=script&lang=js&"
export * from "./houseConnectionForm.vue?vue&type=script&lang=js&"
import style0 from "./houseConnectionForm.vue?vue&type=style&index=0&id=8b96b4f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b96b4f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCheckbox,VForm,VSelect,VTextField})
